/* @flow */

import React from 'react';
import IconHeader from 'shared/components/IconHeader';

const Header = () => <IconHeader icon="book" circular title="Catalogue" />;

export default Header;



// WEBPACK FOOTER //
// ./src/modules/catalog/screens/Header.js